import { apiSlice } from './baseApi';
import { DEFAULT_PAGE_LIMIT } from '@constants/appDefaults';

export const customerApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCustomers: builder.query({
      query: ({ companyId, tableFilterOutcomingData, page, limit = DEFAULT_PAGE_LIMIT }) => ({
        url: '/customer/get-all-customer',
        method: 'POST',
        body: {
          company_id: companyId,
          tableFilterOutcomingData,
          page,
          limit,
        },
      }),
      transformResponse: (response) => ({
        customers: response?.customers ?? [],
        totalPages: response?.totalPages ?? 1,
      }),
      providesTags: ['Customers'],
    }),
    getUserCustomers: builder.query({
      query: ({ companyId, userId, tableFilterOutcomingData, page }) => ({
        url: '/customer/get-all-users-customer',
        method: 'POST',
        body: {
          company_id: companyId,
          user_id: userId,
          tableFilterOutcomingData,
          page,
        },
      }),
      transformResponse: (response) => ({
        customers: response?.customers ?? [],
        totalPages: response?.totalPages ?? 1,
      }),
      providesTags: ['Customers'],
    }),
    changeCustomerStatus: builder.mutation({
      query: (body) => ({
        url: '/customer/change-customer-status',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Customers'],
    }),
    deleteCustomer: builder.mutation({
      query: (body) => ({
        url: '/customer/delete-customer',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Customers'],
    }),
    toggleCustomerBotStatus: builder.mutation({
      query: (body) => ({
        url: '/customer/toggle-agent-status',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Customers'],
    }),
    addCustomer: builder.mutation({
      query: (body) => ({
        url: '/customer/add-new-customer',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Customers'],
    }),
    editCustomer: builder.mutation({
      query: (body) => ({
        url: '/customer/edit-customer',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Customers', 'Invoices', 'Orders', 'ServiceItems'],
    }),
  }),
});
